import { rootStore } from "../store";

export const checkResponseStatusAndLogout = async () => {
  const { authStore } = rootStore;
  await authStore.refresh();
};